import { Component, OnInit, Input } from '@angular/core';
import { WorkspacesInfo } from 'src/app/models';

@Component({
    selector: 'app-workspaces-info',
    templateUrl: './workspaces-info.component.html',
    styleUrls: ['./workspaces-info.component.scss'],
    standalone: false
})
export class WorkspacesInfoComponent implements OnInit {

  @Input() workspace: WorkspacesInfo;

  constructor() { }

  ngOnInit() { }

}
